import { z } from "zod";
import {
    AdminProjectDetailSchema,
    AdminProjectSummarySchema,
    ClientInboxLeadGroupSchema,
    ExpertInboxProjectSchema,
    ParticipantDisplayMapSchema,
    ProjectDetailSchema,
    ProjectMediaResourceSchema,
    ProjectSummarySchema,
    RawProjectRecordSchema,
    RawQuoteRecordSchema,
} from "./common";

export const ProjectConfigResponseSchema = z.object({
    quote_payments: z.object({
        default_currency: z.string().trim().length(3).transform((value) => value.toUpperCase()).default("USD"),
        supported_currencies: z.array(z.string().trim().length(3).transform((value) => value.toUpperCase())).default(["USD"]),
    }),
});
export type ProjectConfigResponse = z.infer<typeof ProjectConfigResponseSchema>;

export const ClientProjectsInboxItemSchema = ClientInboxLeadGroupSchema;
export type ClientProjectsInboxItem = z.infer<typeof ClientProjectsInboxItemSchema>;

export const ExpertProjectsInboxItemSchema = ExpertInboxProjectSchema;
export type ExpertProjectsInboxItem = z.infer<typeof ExpertProjectsInboxItemSchema>;

export const GenericProjectListResponseItemSchema = ProjectSummarySchema;
export type GenericProjectListResponseItem = z.infer<typeof GenericProjectListResponseItemSchema>;

export const ProjectDetailResponseSchema = ProjectDetailSchema;
export type ProjectDetailResponse = z.infer<typeof ProjectDetailResponseSchema>;

export const ProjectParticipantsDisplayResponseSchema = ParticipantDisplayMapSchema;
export type ProjectParticipantsDisplayResponse = z.infer<typeof ProjectParticipantsDisplayResponseSchema>;

export const UpdateProjectStatusResponseSchema = RawProjectRecordSchema;
export type UpdateProjectStatusResponse = z.infer<typeof UpdateProjectStatusResponseSchema>;

export const ProjectQuoteResponseSchema = RawQuoteRecordSchema;
export type ProjectQuoteResponse = z.infer<typeof ProjectQuoteResponseSchema>;

export const ProjectQuoteListItemSchema = RawQuoteRecordSchema;
export type ProjectQuoteListItem = z.infer<typeof ProjectQuoteListItemSchema>;

export const ProjectQuoteCheckoutSessionResponseSchema = z.object({
    checkout_url: z.string().url(),
});
export type ProjectQuoteCheckoutSessionResponse = z.infer<typeof ProjectQuoteCheckoutSessionResponseSchema>;

export const ProjectAttachmentResponseSchema = ProjectMediaResourceSchema;
export type ProjectAttachmentResponse = z.infer<typeof ProjectAttachmentResponseSchema>;

export const AdminProjectListItemSchema = AdminProjectSummarySchema;
export type AdminProjectListItem = z.infer<typeof AdminProjectListItemSchema>;

export const AdminProjectDetailResponseSchema = AdminProjectDetailSchema;
export type AdminProjectDetailResponse = z.infer<typeof AdminProjectDetailResponseSchema>;
